<template>
  <v-container
    :class="{
      'pa-0 ma-0': $vuetify.breakpoint.xs,
    }"
  >
    <v-row
      v-if="
        !$wait.is('loading webshop getProducts') &&
        !$wait.is('loading webshop getProducts')
      "
      class="pt-5"
      no-gutters
    >
      <v-col
        v-if="
          $route.params.categoryFirst &&
          categoriesFilter.find(
            (c) => c.urlSafeName === $route.params.categoryFirst
          )
        "
        class=""
        cols="6"
      >
        <v-list-item style="padding-left: 12px" two-line>
          <v-list-item-content>
            <v-list-item-title
              ><h1>
                {{
                  categoriesFilter.find(
                    (c) => c.urlSafeName === $route.params.categoryFirst
                  ).title
                }}
              </h1>
            </v-list-item-title>
            <v-list-item-subtitle style="font-weight: bold; color: black">
              {{ filteredProductsCount }}
              produkter
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-col>
      <v-col
        :cols="
          $route.params.categoryFirst &&
          categoriesFilter.find(
            (c) => c.urlSafeName === $route.params.categoryFirst
          )
            ? 6
            : 12
        "
        class="pt-3"
        style="text-align: end"
      >
        <v-btn
          v-if="$vuetify.breakpoint.smAndDown"
          class="v-btn--filter -action mr-5"
          color="primary"
          dark
          outlined
          right
          rounded
          @click.stop="drawer = true"
        >
          <v-icon>filter_list</v-icon>
          Filter
        </v-btn>
      </v-col>
    </v-row>
    <div v-if="
          selectedCampaign &&
          $route.name === 'webshopCampaignProducts' &&
          !$wait.is('loading webshop getProducts') &&
          !$wait.is('loading webshop GetCampaignProducts')
        " :class="$vuetify.breakpoint.mdAndUp ? '' : 'px-4'">
      <webshop-selected-campaign-info></webshop-selected-campaign-info>
      <div class="mt-6">
        <p class="font-weight-bold" style="color: var(--v-primary-base)">{{campaign.products && campaign.products.length ? campaign.products.length : 0}} Kampanjeprodukter funnet</p>
      </div>
    </div>
    <v-container fluid class="pa-0" :class="$vuetify.breakpoint.mdAndUp ? '' : 'px-4'">
      <webshop-selected-filter-chips
        v-if="
          !$wait.is('loading webshop getProducts') &&
          !$wait.is('loading webshop GetCampaignProducts')
        "
      ></webshop-selected-filter-chips>
      <webshop-product-list class="mb-6"></webshop-product-list>
    </v-container>

    <v-navigation-drawer
      v-model="drawer"
      :stateless="!filterVisible"
      disable-route-watcher
      fixed
      style="z-index: 201"
      width="100%"
    >
      <v-btn
        absolute
        class="mt-2"
        icon
        right
        style="z-index: 10"
        @click="drawer = false"
      >
        <v-icon>close</v-icon>
      </v-btn>
      <webshop-filter
        v-if="filterVisible"
        :background-color="'transparent'"
        class="pt-7"
      ></webshop-filter>
      <template v-if="$vuetify.breakpoint.smAndDown" v-slot:append>
        <div class="pa-2">
          <v-divider></v-divider>
          <v-btn
            block
            color="primary"
            elevation="0"
            rounded
            @click="drawer = false"
            >Vis produkter ({{ filteredProductsCount }})
          </v-btn>
        </div>
      </template>
    </v-navigation-drawer>
  </v-container>
</template>

<script>
import { WebshopProductList, WebshopSelectedFilterChips } from "../components";
import { getBreadcrumbs } from "@/router/helpers";
import WebshopFilter from "@/components/webshop/WebshopFilter";
import webshopMixins from "@/components/webshop/cart/webshop.mixins";
import WebshopSelectedCampaignInfo from "../components/WebshopSelectedCampaignInfo.vue";

export default {
  data: () => ({
    drawer: false,
  }),
  mixins: [webshopMixins],
  computed: {
    breadcrumbs() {
      return getBreadcrumbs(this.$route.name);
    },
    campaign() {
      return this.$store.getters["campaigns/getCampaign"]
    },
  },
  methods: {},
  components: {
    WebshopSelectedCampaignInfo,
    WebshopFilter,
    WebshopProductList,
    WebshopSelectedFilterChips,
  },
  watch: {
    "$vuetify.breakpoint.smAndDown"(val) {
      if (this.drawer && !val) this.drawer = false;
    },
  },
};
</script>
